import keys from 'lodash.keys'
import Pay from '@edu-fe/pay'
import api from '@edu-fe/api'
import os from '@edu-fe/os'
import login from '@/utils/login'
import module from '../../modules/sign-up'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ScheduleList from '../../components/ScheduleList.vue'
import TryVideo from '../../components/TryVideo.vue'
import TryAudio from '../../components/TryAudio.vue'
import SignUpStudy from '../../components/SignUp/SignUpStudy.vue'
import SignUpBottom from '../../components/SignUp/SignUpBottom.vue'
import SignUpCoupon from '../../components/SignUp/SignUpCoupon.vue'
import UiTab from '../../components/UI/Tab.vue'
import ShareMaker from '../../lib/shareMaker'
import SignUpVipBar from '../../components/SignUp/SignUpVipBar'
import SignUpGroup from '../../components/SignUp/SignUpGroup'
import SignUpGroupRule from '../../components/SignUp/SignUpGroupRule'
import CourseTypeBar from '../../components/CourseTypeBar'
import Notice from '../../components/Notice'
import RetainBubble from '../../components/RetainBubble'
import { downloadApp, isxxx } from '@mixins'
import SignInfo from '../../lib/signInfo'
import { pay } from '@/utils/pay'
import randomCode from '@/utils/randomCode'
import InitShare from '../../lib/initShare' // eslint-disable-line
import Cookie from 'js-cookie'

function check(element) {
  if (element.scrollTop) {
    element.scrollTop = 0
  }
  if (element.children.length) {
    for (let i = 0; i < element.children.length; i++) {
      check(element.children[i])
    }
  }
}

export default {
  data() {
    return {
      paying: false,
      isTryVideoShow: false,
      isLoanApp: os.name === 'loan',
      autoPayFlag: true
    }
  },

  computed: {
    ...mapState(['launchOptions', 'userInfo']),
    ...mapState(module.name, keys(module.state())),
    ...mapGetters(module.name, keys(module.getters)),

    isScheduleVisible() {
      return this.tabIndex === 1
    },

    details() {
      return this.tryInfo.videoUrl
        ? this.images
        : this.images.slice(1, this.images.length)
    },

    // vip 相关
    saved() {
      return Number(this.priceInfo.price - this.priceInfo.vipPrice, 2).toFixed(2)
    },

    groupLength() {
      return this.groupLists.length
    },

    groupShow() {
      return this.courseInfo.isGroupCourse && this.pingAble && !this.hasBuy && !this.courseInfo.groupId
    },

    groupRuleShow() {
      return this.courseInfo.isGroupCourse && this.pingAble && !this.hasBuy
    },

    // 活动剩余时间
    totalEndTime() {
      return this.courseInfo.discountEndTime - this.courseInfo.systemDate
    },

    effectivePrice() {
      return this.priceInfo.isInAct && this.priceInfo.activityPrice < this.priceInfo.price
        ? this.priceInfo.activityPrice
        : this.priceInfo.price
    },

    effectiveVipPrice() {
      return this.priceInfo.isInAct && this.priceInfo.activityPrice < this.priceInfo.vipPrice
        ? this.priceInfo.activityPrice
        : this.priceInfo.vipPrice
    },

    realityPrice() {
      return this.isVip ? this.effectiveVipPrice : this.effectivePrice
    },

    autoPay() {
      return this.$route.query['_edu_auto_pay']
    }
  },

  watch: {
    courseInfo(data) {

      return new ShareMaker({
        title: data.title,
        introduction: data.recommendWord || data.title,
        imgUrl: data.tryImage,
        link: `https://course-m.auoktalk.com/sign-up?courseId=${this.courseId}`
      }, location.href, true)
    },

    userInfo: {
      handler(e = {}) {
        const { userId } = e
        const { courseId } = this.$route.query
        if (userId) {
          try {
            api.mine.track({
              client: 2,
              courseId,
              position: 1,
              type: 1,
              userId
            })()
          } catch (e) {
            console.log(e)
          }
        }
      },
      deep: true
    },
    autoPay: {
      handler(val) {
        if (this.autoPayFlag && val) {
          window.sessionStorage.setItem('autoPay', val)
        }
      },
      immediate: true
    }
  },

  beforeRouteEnter(to, from, next) {
    if (from.query['_edu_auto_pay']) {
      return next(vm => {
        vm.autoPayFlag = false
      })
    }

    next()
  },

  mixins: [
    downloadApp,
    isxxx
  ],

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    ...mapMutations(['signUpCourse']),
    handlerClick() {
      this.isTryVideoShow = true
      if (this.courseInfo.qrcode) {
        return this.$refs.notice.show()
      }
      // window.location.href = this.courseInfo.appDownloadUrl
      this.download('yyb4')
    },

    async sign() {
      const wpsSid = await login.getWpsSid()
      // wuyingbo
      // const wpsSid = '123456'
      if (!wpsSid) {
        return login.login()
      }
      if (os.type === 'browser' || this.isWpsIos) {
        return this.$router.push('vip')
      }
      SignInfo.sign({
        cardType: 1,
        from: this.$route.query.from
      })
    },

    closeBubble() {
      this.isTryVideoShow = false
    },

    // 给 #app 元素加上 overflow：hidden，防止其随意滑动
    setAppOverflow(value) {
      const app = document.querySelector('#app')
      window.overscroll(document.querySelector('body'))
      app.style.overflow = value
    },

    tab(index) {
      this.setTab(index)
    },

    // 跳转到知识合伙人海报制作页面
    toMakePoster() {
      this.$router.push({
        name: 'poster',
        query: {
          courseId: this.courseId,
          type: this.type || 1
        }
      })
    },

    // 上报
    report() {
      let reported = false
      let self = this

      function doReport() {
        if (!reported) {

          reported = true
        } else {
          window.removeEventListener('scroll', doReport)
        }
      }

      window.addEventListener('scroll', doReport)
    },

    buyInfo(isSend) {
      return {
        courseId: this.courseId,
        type: this.courseInfo.type || 1,
        from: this.$route.query['order_from'] || this.launchOptions.from || '',
        token: this.$route.query.token,
        market: this.$route.query.market || '',
        gotoResult: orderId => {
          // 因 successCallback 废弃，因此在几种回调中处理支付状态
          this.paying = false

          const page = location.protocol + '//' + location.host + '/sign-up-result-ok2?orderId=' + orderId + '&courseId=' + this.courseId

          // 分期客户端结果页
          if (os.name === 'loan' && window.jsBridge) {
            return window.jsBridge.goToEduSuccess(JSON.stringify({
              page: 'KSWPSPageController',
              animated: false,
              urlString: page
            }))
          }

          // 1元训练营 展示二维码
          if (
            (os.type === 'weixin' || (os.name === 'wps' && os.type === 'app')) &&
            this.courseInfo.isPromote === 1
          ) {
            // return window.location.replace(`/sign-up-result-for-promote?courseId=${this.orderId}`)
            return this.$router.replace({
              name: 'sign-up-result-for-promote',
              query: {
                courseId: this.courseId
              }
            })
          }

          // TODO: 0元课购买判断

          location.href = page
        },
        gotoPayment: () => {
          alert('2 gotopayMent')
          // 同 line 215
          this.paying = false
          window.sessionStorage.clear()
          console.log('--- this playing:' + this.playing)
          this.$router.push({
            name: 'pay',
            query: {
              courseId: this.courseId,
              market: this.$route.query.market || '',
              isSend,
              token: this.$route.query.token,
              '_edu_auto_pay': this.autoPay
            }
          })
        },
        hasBuyCallback: () => {
          this.paying = false
          this.$toast.show({
            message: '已购买'
          })
        },
        loginCallback: wpsSid => {
          this.paying = false
          this.init()
        },
        failCallback: () => {
          this.paying = false
        },
        cancelCallback: async () => {
          // await this.getRetain()
          this.paying = false
          this.$refs.retain.show()
        }
      }
    },

    // 分享
    share() {
      this.shareComponent = this.$share()
    },

    // 去学习
    learn() {

      // const page = location.protocol + '//' + location.host + '/sign-up-result-ok2?orderId=' + orderId + '&courseId=' + this.courseId
      // 只展示二维码 没有下一步操作
      if (this.$route.query.action === 'bothCode') {
        this.$refs.noticeBothCode.show()
        return
      }

      // 一元训练营点学习直接去二维码
      if (
        (os.type === 'weixin' || (os.type === 'app' && os.name === 'wps')) &&
        (this.courseInfo.isPromote === 1 || this.courseInfo.campType > 0)
      ) {
        // return window.location.assign(`/sign-up-result-for-promote?courseId=${this.courseId}`)
        return this.$router.push({
          name: 'sign-up-result-for-promote',
          query: {
            courseId: this.courseId
          }
        })
      }
      if (this.courseInfo.courseType === 8) {
        this.wxQrCode('study')
      } else {
        if (this.courseId === 'f67434b66fb4456884ba69d495c80265') {
          this.$router.push(`/sign-up-result-ok2?courseId=${this.courseId}`)
        } else {
          this.$router.push(`/schedule?courseId=${this.courseId}`)
        }
      }
    },

    // 购买
    buy() {
      let that = this
      const params = {
        type: 1,
        price: parseInt(Number(this.courseInfo.price) * 100),
        goodsId: this.courseId,
        subject: this.courseInfo.title,
        frontTradeNo: randomCode(),
        channel: 2,
        succ: async () => {
          this.wxQrCode()
          await that.init({ query: that.$route.query, loadingComponent: that.$loading })
        }
      }
      pay(params, this)
    },

    wxQrCode(type = '') {
      this.$axios.get(`https://course.auoktalk.com/api/platform/user/mic/program/qr/code?userId=${Cookie.get('openid')}&courseId=${this.courseId}&micProgramAppId=${this.$route.query.micProgramAppId || ''}`).then(res => {
        const { data: { data = '' } } = res
        this.courseInfo['courseId'] = this.courseId
        this.courseInfo['qrCodeImage'] = data
        this.signUpCourse(this.courseInfo)
        if (type !== '') {
          this.$router.push('wx-service')
        } else {
          this.$router.push('pay-success')
        }
      })
    },

    // 赠送好友
    send() {
      this.buy(1)
    },

    buyGroup(groupId = 0, index) {
      return new Pay({
        courseId: this.courseInfo.groupCourseId,
        type: 7,
        from: this.$route.query['order_from'] || this.launchOptions.from,
        price: this.courseInfo.groupPrice,
        market: this.$route.query.market || '',
        payment: true,
        payWay: 10,
        token: this.$route.query.token,
        groupId,
        gotoResult: orderId => this.rerender(),
        gotoPayment: () => {
          alert('1 go to payMent')
          this.$router.push({
            name: 'pay',
            query: {
              courseId: this.courseId,
              isSend: 0,
              token: this.$route.query.token
            }
          })
        }
      })
    },

    // 加入 WPS 会员
    joinWPSVip() {
      const cbUrl = location.protocol + '//' + location.host + '/sign-up?courseId=' + this.courseId
      location.assign('http://vip.wps.cn/wap/pay?csource=android_vip_jingpinke&memtype=20&from=' + this.courseId + '&cb=' + encodeURIComponent(cbUrl))
    },

    handleFoldSection(section) {
      this.toggleSpreadSchedule(section)
    }
  },

  beforeCreate() {
    this.$store.registerModule(module.name, module)
  },

  async created() {
    await InitShare._init()
    await this.init({ query: this.$route.query, loadingComponent: this.$loading })
    let autoPay = window.sessionStorage.getItem('autoPay')
    if (autoPay && this.autoPayFlag) {
      this.buy()
    }
    const courseId = this.courseId
    Pay.enterPayment(orderId => {
      const page = location.protocol + '//' + location.host + '/sign-up-result-ok2?orderId=' + orderId + '&courseId=' + courseId
      window.location.href = page
    })
  },

  async mounted() {
    try {
      check(document.documentElement)
    } catch (e) {
      console.log(e)
    }
    this.setTab(Number(this.$route.query.tabIndex || 0))
    this.report()
  },

  beforeDestroy() {
    window.sessionStorage.clear()
    this.$loading.hide()
    this.shareComponent && this.shareComponent.close()
    this.$store.unregisterModule(module.name)
    Pay.leavePayment()
  },

  components: {
    ScheduleList,
    TryAudio,
    TryVideo,
    SignUpStudy,
    SignUpBottom,
    UiTab,
    SignUpCoupon,
    SignUpVipBar,
    SignUpGroup,
    SignUpGroupRule,
    CourseTypeBar,
    Notice,
    RetainBubble
  }
}
